import React from "react";
import "./styles.scss";

import { Country } from "../../../shared/constants/Constant";
import ApplicationMalaysia from "./ApplicationMalaysia";
import ApplicationSrilanka from "./ApplicationSrilanka";
import ApplicationBosnia from "./ApplicationBosnia";
import ApplicationJamaica from "./ApplicationJamaica";
import ApplicationIndia from "./ApplicationIndia";
import ApplicationIndonesia from "./ApplicationIndonesia";

interface IProps {
  country: Country;
}

const Application = (props: IProps) => {
  switch (props.country) {
    case Country.MALAYSIA:
      return <ApplicationMalaysia />;
    case Country.INDONESIA:
      return <ApplicationIndonesia />;
    case Country.INDIA:
      return <ApplicationIndia />;
    case Country.SRI_LANKA:
      return <ApplicationSrilanka />;
    case Country.JAMAICA:
      return <ApplicationJamaica />;
    default:
      return <ApplicationBosnia />;
  }
};

export default Application;
